import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKey01 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5925 6.66657C12.5925 6.28744 12.4479 5.90831 12.1586 5.61905C11.8693 5.32977 11.4902 5.18513 11.1111 5.18513M11.1111 11.1111C13.5657 11.1111 15.5555 9.12121 15.5555 6.66661C15.5555 4.21201 13.5657 2.22217 11.1111 2.22217C8.65646 2.22217 6.66661 4.21201 6.66661 6.66661C6.66661 6.86934 6.68019 7.06889 6.70647 7.26442C6.74971 7.58601 6.77132 7.7468 6.75677 7.84853C6.74161 7.9545 6.72232 8.01161 6.67009 8.10506C6.61994 8.19476 6.53158 8.28312 6.35486 8.45985L2.5693 12.2454C2.44119 12.3735 2.37713 12.4376 2.33132 12.5123C2.29071 12.5786 2.26078 12.6509 2.24263 12.7264C2.22217 12.8117 2.22217 12.9023 2.22217 13.0835V14.3703C2.22217 14.7852 2.22217 14.9926 2.3029 15.1511C2.37392 15.2904 2.48724 15.4037 2.62662 15.4748C2.78507 15.5555 2.9925 15.5555 3.40735 15.5555H5.18513V14.074H6.66661V12.5925H8.14809L9.31782 11.4228C9.49455 11.2461 9.58291 11.1577 9.67261 11.1076C9.76606 11.0554 9.82317 11.0361 9.92914 11.0209C10.0309 11.0063 10.1917 11.028 10.5133 11.0712C10.7088 11.0975 10.9083 11.1111 11.1111 11.1111Z",
		stroke: "currentColor",
		strokeWidth: 1.48148,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	})
});
export default SvgKey01;
